/**
 * Facet filters for FilterRail — merged from plugins + build-time fields.
 */

import type { Skill } from "./types";
import { listPlugins, type FacetFilterDef } from "./plugins/types";

export type { FacetFilterDef } from "./plugins/types";

/** Build-time / registry fields not tied to a single plugin. */
const BUILD_FACET_DEFS: FacetFilterDef[] = [
  {
    id: "hasScripts",
    label: "Has scripts/",
    match: (s) => Boolean(s.hasScripts || s.facets?.hasScripts),
  },
  {
    id: "hasAgents",
    label: "Has agents/",
    match: (s) => Boolean(s.hasAgents || s.facets?.hasAgents),
  },
];

export function getFacetFilterDefs(): FacetFilterDef[] {
  const pluginDefs = listPlugins().flatMap((p) => p.facetFilters ?? []);
  const seen = new Set<string>();
  const out: FacetFilterDef[] = [];
  for (const d of [...pluginDefs, ...BUILD_FACET_DEFS]) {
    if (seen.has(d.id)) continue;
    seen.add(d.id);
    out.push(d);
  }
  return out;
}

export function getFacetFilterIds(): string[] {
  return getFacetFilterDefs().map((d) => d.id);
}

export function defaultFacetFilters(): Record<string, boolean> {
  return Object.fromEntries(getFacetFilterIds().map((id) => [id, false]));
}

export function countFacetMatches(skills: Skill[], id: string): number {
  const def = getFacetFilterDefs().find((d) => d.id === id);
  if (!def) return 0;
  return skills.filter((s) => def.match(s)).length;
}

export function skillMatchesFacetFilters(skill: Skill, active: Record<string, boolean>): boolean {
  for (const def of getFacetFilterDefs()) {
    if (active[def.id] && !def.match(skill)) return false;
  }
  return true;
}